import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import Home from "../pages/home/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/pokemon9-casino-review",
    element: <Home />,
  },
  {
    path: "/pokemon9-casino-registration",
    element: <Home />,
  },
  {
    path: "/pokemon9-casino-bonuses",
    element: <Home />,
  },
  {
    path: "/pokemon9-casino-games",
    element: <Home />,
  },
  {
    path: "/pokemon9-casino-payments",
    element: <Home />,
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
];

export default routes;
